module.exports = __webpack_public_path__ + "img/combate_5000ml.55d2fb62.png";